export default [
  // City College
  {
    id: 'sg1',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    name: 'Science Department',
    groupType: 'REGISTRATION',
    teacherCount: 18,
    studentCount: 0,
    hasBeenReviewed: false,
  },
  {
    id: 'sg2',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    name: 'Arts & Humanities',
    groupType: 'REGISTRATION',
    teacherCount: 32,
    studentCount: 5,
    hasBeenReviewed: true,
  },
  {
    id: 'sg3',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    name: 'Student Council 2024',
    groupType: 'YEAR',
    teacherCount: 4,
    studentCount: 20,
    hasBeenReviewed: false,
  },
  // system error accounts (Doyle Elementary School):
  {
    id: 'sg4',
    purchaserId: '12003',
    action: 'CREATE_NEW_RECORD',
    name: 'Homeroom 4B',
    groupType: 'REGISTRATION',
    teacherCount: 1,
    studentCount: 18,
    systemErrorMessage: 'A group system error message from the service',
    hasBeenReviewed: true,
  },
  // errored groups (Greendale Community College):
  {
    id: 'sg5',
    purchaserId: '10002',
    action: 'CREATE_NEW_RECORD',
    name: 'Chess Club',
    groupType: 'YEAR',
    teacherCount: 1,
    studentCount: 12,
    errorCode: 'GROUP_ALREADY_EXISTS',
    hasBeenReviewed: true,
  },
];
